// removed by extract-text-webpack-plugin
module.exports = {"container":"App__container___1yge3","container-padding":"App__container-padding___3ifMN","sf-admin-title":"App__sf-admin-title___1uxFz"};